var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Seguro (Opcional)",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "compania",
      "label-for": "compania",
      "label": "Compania"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "50",
      "autofocus": ""
    },
    model: {
      value: _vm.form.compania,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "compania", $$v);
      },
      expression: "form.compania"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "cnpj_compania",
      "label-for": "cnpj_compania",
      "label": "CNPJ Compania"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "cnpj_compania",
      "name": "cnpj_compania"
    },
    nativeOn: {
      "input": function input($event) {
        return _vm.onCpfCnpjInput($event, _vm.form, 'cnpj_compania');
      }
    },
    model: {
      value: _vm.form.cnpj_compania,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cnpj_compania", $$v);
      },
      expression: "form.cnpj_compania"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "apolice",
      "label-for": "apolice",
      "label": "Apólice"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "22"
    },
    model: {
      value: _vm.form.apolice,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "apolice", $$v);
      },
      expression: "form.apolice"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "tipo_responsavel",
      "label-for": "tipo_responsavel",
      "label": "Tipo Responsável"
    }
  }, [_c('VueSelect', {
    ref: "tipo_responsavel",
    class: {
      hasErrors: _vm.tipoResponsavelError
    },
    attrs: {
      "filterable": false,
      "searchable": false,
      "options": _vm.tiposResponsavel
    },
    on: {
      "input": function input() {
        return _vm.tipoResponsavelError = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.tipo_responsavel,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tipo_responsavel", $$v);
      },
      expression: "form.tipo_responsavel"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o tipo de responsável ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "responsavel_identificacao",
      "label-for": "responsavel_identificacao",
      "label": "Identificação do Responsável"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "22"
    },
    model: {
      value: _vm.form.responsavel_identificacao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "responsavel_identificacao", $$v);
      },
      expression: "form.responsavel_identificacao"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "averbacoes",
      "label-for": "averbacoes",
      "label": "Averbações"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "5"
    },
    model: {
      value: _vm.averbacaoToAdd,
      callback: function callback($$v) {
        _vm.averbacaoToAdd = $$v;
      },
      expression: "averbacaoToAdd"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label-for": "add"
    }
  }, [_c('button', {
    on: {
      "click": function click($event) {
        return _vm.addAverbacao(_vm.averbacaoToAdd);
      }
    }
  }, [_vm.windowWidth > 768 ? _c('Plus', {
    staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2 mt-9"
  }) : _c('button', {
    staticClass: "btn btn-info btn-hover-dark font-weight-bolder font-size-lg ml-2"
  }, [_vm._v(" Adicionar averbação ")])], 1)])], 1)], 1), _c('table', {
    staticClass: "table table-head-bg table-vertical-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Averbações adicionadas")]), _c('th')])]), _c('tbody', _vm._l(_vm.form.averbacoes, function (averbacao, index) {
    return _c('tr', {
      key: 'item' + index
    }, [_c('td', {
      staticClass: "text-muted font-weight-bold d-block pl-7"
    }, [_vm._v(" " + _vm._s(averbacao) + " ")]), _c('td', [_c('div', {
      staticClass: "row-actions",
      staticStyle: {
        "text-align": "right !important"
      }
    }, [_c('span', {
      staticStyle: {
        "overflow": "visible",
        "position": "relative",
        "width": "130px"
      }
    }, [_c('div', {
      staticClass: "action-buttons"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
      on: {
        "click": function click($event) {
          return _vm.handleDeleteAverbacao(index);
        }
      }
    }, [_c('TrashCanIcon', {
      attrs: {
        "size": 16
      }
    })], 1)])])])])]);
  }), 0)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };